module.exports = __webpack_public_path__ + "static/media/25.f44dd5a0.png";